<template>
    <div class="content">
        <div class="siftitem">
            <div v-for="(goods, gIndex) in showGoodsList" class="itemb" @click="clickGood(goods.id, 0)">
                <div class="itemimg">
                    <img :src="goods.image">
                </div>
                <div class="itemtext">
                    <span>{{ goods.storeName }}</span>
                </div>
                <div class="itempic">
                    <i>￥</i>
                    <span>{{ goods.price }}</span>
                    <b>/{{ goods.unitName }}</b>
                </div>
            </div>
        </div>
    </div>
</div></template>
<script  name='siftitem'>
import {
    getProducts
} from '@/api/indexpage.js'
import store from '@/store'
import { getToken } from '@/axios/cookies.js'
import { getCates } from '@/api/noticedetail.js'
export default {
    props: { obj: Object },
    data() {
        return {
            //展示的商品
            showGoodsList: [],
        }
    },
    mounted() {
        this.getGoodsList({ isIntegral: 0, news: 0, sid: '', limit: 5, page: 1 });
    },
    methods: {
        //获取商品列表
        async getGoodsList(listquery) {
            let res = await getProducts(listquery)
            if (res.status === 200) {
                const token = getToken()
                if (token === undefined) {
                    res.data.forEach((item) => {
                        item.price = '登录查看';
                    });
                }
                this.showGoodsList.length = 0
                this.showGoodsList.push(...res.data)
            }
        },
        clickGood(id, type) {
            this.$router.push({
                path: '/productDetail',
                query: {
                    productId: id,
                    type: type
                }
            })
        }
    },
}

</script>
<style scoped lang='less'>
/* scoped 使用得定义的样式只在本页面内生效  */
.content {
    width: 100%;

    .siftitem {
        width: 1440px;
        margin: 20px auto;
        display: flex;
        flex-wrap: nowrap;

        .itemb {
            width: 20%;
            height: 325px;
            padding: 10px;
            box-sizing: border-box;
            cursor: pointer;
            margin: 0 10px;
            background-color: #fff;
            border-radius: 5px;
            &:hover {
                box-shadow: 0 0 5px 0 rgba(0, 0, 0, .2);

                .itemtext {
                    color: #f74747;
                }

            }

            .itemimg {
                width: 100%;
                height: 200px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .itemtext {
                width: 100%;
                height: 36px;
                line-height: 18px;
                font-size: 14px;
                margin: 15px 0;
                color: #333;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                cursor: pointer;
            }

            .itempic {
                width: 100%;
                line-height: 36px;

                i {
                    font-size: 14px;
                    color: #f74747;
                    font-style: normal;
                }

                span {
                    font-weight: 900;
                    color: #f74747;
                    font-size: 20px;
                }

                b {
                    font-size: 14px;
                    color: #333;
                    font-weight: 400;
                }
            }
        }
    }
}
</style>
 


// WEBPACK FOOTER //
// src/views/PageIndex/indexAll/components/NewsGoodsList.vue